import React from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import TagList from "./TagList";

/** Icon + title + tag pills. Used for the home page skill grid. */
const SkillCard = ({ title, Icon, tech }) => (
  <Paper
    sx={(theme) => ({
      display: "flex",
      flexDirection: "column",
      height: "100%",
      p: 2,
      borderRadius: 2.5,
      textAlign: "left",
      border: theme.tokens.hairline,
      backgroundColor: theme.palette.background.paper,
      boxShadow: theme.tokens.cardShadow,
      transition: theme.transitions.create(["box-shadow", "transform"], {
        duration: 250,
      }),
      "&:hover": {
        transform: "translateY(-3px)",
        boxShadow: theme.tokens.cardShadowHover,
      },
    })}
  >
    <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.5 }}>
      {Icon && <Icon fontSize="small" aria-hidden />}
      <Typography variant="h3">
        {title}
      </Typography>
    </Box>
    <TagList tags={tech} size="small" />
  </Paper>
);

export default SkillCard;
